module.exports = new __parcel__URL__("Warlock_07.dbd20466.png").toString();